export default function validateCheckboxFields(subscriptionForms) {
    return (function () {
        /*
         * Sets the blog product input value with the blogProductArr
         * @return {void}
         * @param {blogProductArr}
         * */
        const setBlogProductInputValue = (form, blogProductArr) => {
            const blogProductField = form.querySelector('input[name=blog_product]');
            if (blogProductField && blogProductField.type === 'hidden') {
                blogProductField.setAttribute('value', blogProductArr);
            }
        };

        /*
         * Handles the current unchecked checkbox: if the value of the unchecked checkbox
         * is in the blogProductArr, it removes that value from the array
         * @return {void}
         * @param {blogProductArr, checkbox}
         * */
        const removeUncheckedCheckboxValueFromArray = (blogProductArr, checkbox) => {
            if (blogProductArr.includes(checkbox.value)) {
                blogProductArr.splice(blogProductArr.indexOf(checkbox.value), 1);
            }
        };

        /*
         * Update blog_product field with currently selected option(s)
         * @return {void}
         * */
        const updateBlogProductInput = (form, checkbox, blogProductArr) => {
            if (checkbox.checked) {
                // add new checked checkbox value to blogProductArr
                blogProductArr.push(checkbox.value);
            } else {
                // remove unchecked checkbox value from blogProductArr
                removeUncheckedCheckboxValueFromArray(blogProductArr, checkbox);
            }

            // update blog_product hidden field
            setBlogProductInputValue(form, blogProductArr);
        };

        /*
         * Returns true if at least one checkbox has been checked
         * @return {bool}
         * */
        const checkedOneCheckbox = checkboxes => {
            return Array.prototype.slice
                .call(checkboxes)
                .some(checkbox => checkbox.checked);
        };

        /*
         * Adds or removes the error message display class depending on passed argument
         * @return {void}
         * @param {addOrRemoveClass}
         * */
        const toggleErrorMessageDisplayClass = (addOrRemoveClass, errorElement) => {
            if (errorElement && typeof addOrRemoveClass === 'string') {
                errorElement.classList[addOrRemoveClass]('js-label-message-error');
                const checkboxInputs = errorElement.parentElement.querySelector(
                    '[data-form=checkbox-inputs]'
                );
                if (checkboxInputs)
                    checkboxInputs.classList[addOrRemoveClass]('js-checkbox-group-error');
            }
        };

        /*
         * Prevents default button click behaviour if no checkbox has been checked, then shows the error message
         * @return {void}
         * @param {e}
         * */
        const buttonClickEventHandler = (checkboxes, errorElement, e) => {
            if (!checkedOneCheckbox(checkboxes)) {
                e.preventDefault();
                toggleErrorMessageDisplayClass('add', errorElement);
            }
        };

        /*
         * Listens for the submit button click event
         * @return {void}
         * */
        const submitButtonClickEventListener = (form, checkboxes, errorElement) => {
            const formSubmitButton = form.querySelector('button[type=submit]');

            if (formSubmitButton) {
                formSubmitButton.addEventListener(
                    'click',
                    buttonClickEventHandler.bind(this, checkboxes, errorElement)
                );
            }
        };

        /*
         * Listens for the checkbox input change event
         * @return {void}
         * */
        const checkboxInputChangeListener = (form, checkboxes, errorElement) => {
            const blogProductArr = [];
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', function () {
                    toggleErrorMessageDisplayClass('remove', errorElement);
                    updateBlogProductInput(form, checkbox, blogProductArr);
                });
            });
        };

        /*
         * Init checkbox listeners
         * @return {void}
         * */
        const init = () => {
            subscriptionForms.forEach(form => {
                const checkboxes = form.querySelectorAll('input[type=checkbox]');
                const errorElement = form.querySelector(
                    '[data-form=checkbox-group] [data-form=error]'
                );

                if (checkboxes && checkboxes.length > 0) {
                    submitButtonClickEventListener(form, checkboxes, errorElement);
                    checkboxInputChangeListener(form, checkboxes, errorElement);
                }
            });
        };

        return {
            init,
        };
    })().init();
}
